import { generateClient } from "aws-amplify/api";
import { transformTasks } from "./transform";
import { BULK_COMPLETE_TASKS, TASKS, TASK_ASSIGNMENT, TASKS_FILTER_STATE } from "../actions-index";
import * as Mutations from "../graphql/mutations";
import * as Queries from "../graphql/queries";
import { ACTION_STATUS, AWS_LAMBDA, ERROR_TYPE } from "../util/constants";
import { buildAction } from "../util/functions";

const API = generateClient();

export function getTasks(external = false, limit = null) {
    return async (dispatch, getState) => {
        const state = await getState();
        const externalKeys = state?.authentication?.user?.externalKeys;
        try {
            dispatch(buildAction(TASKS, { status: ACTION_STATUS.LOADING }));
            const params = {
                query: Queries.getTasks
            }
            if(external && externalKeys){
                params.authMode = AWS_LAMBDA;
                params.authToken = `${externalKeys.ukey}:${externalKeys.akey}`
            }
            if(Number.isInteger(limit)) params.limit = limit;
            const response = await API.graphql(params);
            const tasks = (response?.data?.getTasks?.tasks ?? []);
            dispatch(buildAction(TASKS, { status: ACTION_STATUS.SUCCESS, data: transformTasks(tasks) }));
        } catch(error) {
            console.error("Get Tasks Error: ", error);
            dispatch(buildAction(TASKS, { status: ACTION_STATUS.ERROR }));
        }
    };
}

function taskAssignment(query, variables, wfId, assignee = "") {
    return async (dispatch) => {
        try {
            dispatch(buildAction(TASK_ASSIGNMENT, { wfId, status: ACTION_STATUS.LOADING }));
            await API.graphql({ query, variables });
            dispatch(buildAction(TASK_ASSIGNMENT, { wfId, status: ACTION_STATUS.SUCCESS, assignee }));
        } catch(error) {
            console.error("Task Assignment Error: ", error);
            dispatch(buildAction(TASK_ASSIGNMENT, { wfId, status: ACTION_STATUS.ERROR }));
        }
    };
}

export function assignTask(wfId, emplid, formId, formType, taskName) {
    return async (dispatch, getState) => {
        const state = getState();
        dispatch(taskAssignment(Mutations.assignTask, { emplid, formId, formType, taskName }, wfId, state.authentication.user.name));
    };
}

export function unassignTask(wfId, emplid, formId, formType, taskName) {
    return async (dispatch) => (dispatch(taskAssignment(Mutations.unassignTask, { emplid, formId, formType, taskName }, wfId)));
}

export function setTasksFilterState(filterState) {
    return (dispatch) => (dispatch(buildAction(TASKS_FILTER_STATE, filterState)));
}

export function bulkCompleteTasks(tasks) {
    return async (dispatch) => {
        try {
            dispatch(buildAction(BULK_COMPLETE_TASKS, { status: ACTION_STATUS.LOADING }));
            const response = await API.graphql({ query: Mutations.bulkCompleteTasks, variables: { tasks} });
            const errors = response.data.bulkCompleteTasks.errors;
            dispatch(buildAction(BULK_COMPLETE_TASKS, { status: ACTION_STATUS.SUCCESS, message: (errors === true ? "One or more tasks failed to complete." : null) }));
        } catch(error) {
            console.error("Bulk Complete Tasks Error: ", error);
            let message = null;
            const { errors = [] } = error;
            if(errors.length > 0) {
                const errorType = errors[0].errorType;
                if(errorType === ERROR_TYPE.UNAUTHORIZED) message = "You lack sufficient security permissions to perform bulk complete.";
            }
            dispatch(buildAction(BULK_COMPLETE_TASKS, { status: ACTION_STATUS.ERROR, message }));
        }
    };
}